import { Avatar, Button, IconButton, Grid } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import React from "react";
import Logo from "../../img/logo.png";
import { useSelector } from "react-redux";
import { USER_ROLE } from "../security/UserRole";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: "auto",
  },
  title: {
    flexGrow: 1,
    //color: '#342b64',
    fontWeight: "bold",
    fontSize:30
  },
  appTitle:{
    flexGrow: 1,
    color: '#fff',
  },
  middleTitle:{ 
    flexGrow: 1,
    fontWeight: "thin",
    fontSize:15

  },
  square: {
    borderRadius: 0,
    border: 0,
    boxShadow: "0 0px 0px 0px rgba(0, 0, 0, 0)",
    background: "transparent",
  },
}));

export default function AppLogo() {
  const classes = useStyles();
  const userRole = useSelector((state) =>
    state.authentication &&
    state.authentication.user &&
    state.authentication.user.userRole
      ? state.authentication.user.userRole
      : undefined
  );

  const logo = (
    <Grid container direction="row" justify="center" alignItems="center">
      {/* <Avatar variant="square" src={Logo} className={classes.square}></Avatar> */}
      
        {userRole && userRole === USER_ROLE.PATIENT ? <Typography variant="h3" color="primary" className={classes.appTitle}>PATIENT PORTAL</Typography> : <></>}
        {userRole && userRole === USER_ROLE.DOCTOR ? <Typography variant="h3" color="primary" className={classes.appTitle}>DOCTOR PORTAL</Typography> : <></>}
        {userRole && userRole === USER_ROLE.SYSTEM_ADMIN ? (
          <Typography variant="h3" color="primary" className={classes.appTitle}>SYSTEM ADMIN PORTAL</Typography>
        ) : (
          <></>
        )}
        {userRole && userRole === USER_ROLE.HCP_ADMIN ? (
          <Typography variant="h3" color="primary" className={classes.appTitle}>HCP ADMIN PORTAL</Typography>
        ) : (
          <></>
        )}
        
        {userRole && userRole.length>0 ? <></> : <Typography variant="h3" color="primary" className={classes.title}>Ready<small variant="body2" color="primary" className={classes.middleTitle}>Med</small>Registration</Typography> }
      
    </Grid>
  );
  return <div className={classes.root}>{logo}</div>;
}
